"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _core = require("@focaltec-suite/core");
var _anyform = require("../anyform");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ChipFilterPopup(_ref) {
  var name = _ref.name,
    label = _ref.label,
    value = _ref.value,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    options = _ref.options,
    anchorEl = _ref.anchorEl,
    onClose = _ref.onClose,
    onUpdate = _ref.onUpdate;
  var _useValidatedForm = (0, _anyform.useValidatedForm)(),
    register = _useValidatedForm.register,
    bind = _useValidatedForm.bind;
  var onSubmit = (0, _react.useCallback)(function (event) {
    event.preventDefault();
    onUpdate(bind());
  }, [onUpdate, bind]);
  var input = (0, _react.useMemo)(function () {
    if (options) {
      return /*#__PURE__*/_react["default"].createElement(_anyform.AnyAutocomplete, {
        size: "small",
        margin: "none",
        name: name,
        label: label,
        grouped: options.some(function (el) {
          return el.group;
        }),
        initialValue: value,
        options: options,
        register: register,
        prefillWhenSingle: false
      });
    }
    if (type === 'date') {
      return /*#__PURE__*/_react["default"].createElement(_anyform.AnyDateRange, {
        size: "small",
        margin: "none",
        name: name,
        label: label,
        register: register
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_anyform.AnyInput, {
      type: type,
      size: "small",
      margin: "none",
      name: name,
      label: label,
      initialValue: value,
      register: register
    });
  }, [name, label, value, register, type, options]);
  return /*#__PURE__*/_react["default"].createElement(_material.Popover, {
    open: true,
    anchorEl: anchorEl,
    onClose: onClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    sx: {
      mt: 1
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Card, {
    sx: function sx(theme) {
      return {
        minWidth: theme.spacing(50)
      };
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.CardHeader, {
    title: (0, _core.translate)('filters.title', {
      label: label
    }),
    titleTypographyProps: {
      variant: 'body2'
    }
  }), /*#__PURE__*/_react["default"].createElement(_material.CardContent, {
    sx: {
      mt: 0,
      pt: 0
    }
  }, /*#__PURE__*/_react["default"].createElement("form", {
    autoComplete: "off",
    noValidate: true,
    onSubmit: onSubmit
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    rowSpacing: 1
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, input), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
    type: "submit",
    variant: "contained",
    color: "primary",
    size: "large",
    fullWidth: true
  }, (0, _core.translate)('filters.button'))))))));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(ChipFilterPopup);